export default __webpack_public_path__ + "static/newsItem-image-1-4cf5befced68ede7a8827bf9fbe45bb6.jpg";